// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import ManagerProfilePage from "../pages/ManagerProfile/ManagerProfile";
const __wvcRoutePaths = ["/ManagerProfilePage", "/manager-profile"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["book-appointment", "bookappointmentpage", "home", "homepage", "manager-profile", "managerprofilepage", "post", "project-gallery", "projectgallerypage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<ManagerProfilePage />} />
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<ManagerProfilePage />} />
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
